module.exports = __webpack_public_path__ + "static/media/source_learn_2.642396e6.png";